import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterBy } from "../redux/filter/actions";

export default function FilteringBy() {
  const { author, tag } = useSelector((state) => state.filter);

  if (author.length === 0 && tag.length === 0) {
    return null;
  }

  return (
    <div className="text-center  mt-3">
      <h4 className="text-2xl tracking-tight font-extrabold text-gray-900 sm:text-2xl">
        Filtering By
      </h4>
      <p className="mt-3 max-w-2xl mx-auto text-xl sm:mt-4">
        {author.map((item) => (
          <FilterLabel key={item} label="Author" name="author" value={item} />
        ))}
        {tag.map((item) => (
          <FilterLabel key={item} label="Tag" name="tag" value={item} />
        ))}
      </p>
    </div>
  );
}

function FilterLabel({ label, value, name }) {
  const dispatch = useDispatch();
  return (
    <span
      onClick={() => dispatch(filterBy(name, value))}
      style={{ marginRight: 8 }}
    >
      <span style={{ color: "gray" }}>{label}</span> :{" "}
      <span style={{ textDecoration: "underline" }}>{value}</span>
    </span>
  );
}
